import { debounce } from '../debounce';
import { ScrollHandler } from './handlers';
const scrollHandler = ScrollHandler.instance;
export const debouncedSaveScrollPosition = debounce((href, scrolled) => {
    scrollHandler.saveScrollPosition(href, scrolled);
}, 500);
export const debouncedScrollRestore = debounce((container, pathname, alwaysRestoreScroll) => {
    const savedScrollPosition = scrollHandler.getScrollPosition(pathname);
    const hasScrollRestorationSet = scrollHandler.getScrollRestoration();
    if (!hasScrollRestorationSet && !alwaysRestoreScroll)
        return scrollHandler.saveScrollPosition(pathname, 0);
    container.scrollTo({ top: savedScrollPosition, behavior: 'smooth' });
    if (hasScrollRestorationSet)
        scrollHandler.deleteScrollRestoration();
}, 500);
//# sourceMappingURL=utils.js.map